import { DEFAULT_BRANDING_COLOR, HUB_PRIMARY_COLOR_CSS_VAR, HUB_PRIMARY_TEXT_COLOR_CSS_VAR } from '../../constants';
export var getHubDefaultParameters = function getHubDefaultParameters() {
  return {
    backgroundColor: "var(".concat(HUB_PRIMARY_COLOR_CSS_VAR, ", ", "var(--ds-background-accent-gray-subtler, ".concat(DEFAULT_BRANDING_COLOR, ")"), ")"),
    textColor: "var(".concat(HUB_PRIMARY_TEXT_COLOR_CSS_VAR, ", ", "var(--ds-text, #292A2E)", ")")
  };
};